import React, { Component } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

export default class ProcessingPage extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { className } = this.props;

    return (
      <div className="ProcessingPage full-height">
        <div className={ classnames('spinner-container page-spinner', className) }>
          <span className="spinner gray" />

          <div className="full-width flex middle column gutter">
            <div className="text-gray-600 margin-md-top text-center">
              <FormattedMessage
                id='inbox_guest_update_booking.update_booking_guest_main.processing_payment'
                defaultMessage='Processing your payment...'
              />
            </div>
            <div className="text-gray-600 margin-md-top text-center">
              <FormattedMessage
                id='inbox_guest_update_booking.update_booking_guest_main.do_not_refresh_copy'
                defaultMessage='To avoid potentially being charged more than one time, please do not refresh your browser or click "Back".'
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
